export { type GraphemeBiau, graphemeBiauTable } from "#grapheme-biau-table";
